import { BehaviorSubject, Observable, Subject } from "rxjs";

export abstract class FormValueService<T, R> {
  protected _reset = new Subject<void>();
  protected _value = new BehaviorSubject<T>(null);
  protected _response = new BehaviorSubject<R>(null);

  public get value(): Observable<T> {
    return this._value.asObservable();
  }

  public get response(): Observable<R> {
    return this._response.asObservable();
  }

  public setResponse(response: R): void {
    this._response.next(response);
  }

  public get reset(): Observable<void> {
    return this._reset.asObservable();
  }

  public addValue(addedValue: Partial<T>): void {
    this._value.next({ ...this._value.value, ...addedValue });
  }

  public setValue(newValue: T): void {
    this._value.next(newValue);
  }

  public resetForm(): void {
    this._value.next(null);
    this._response.next(null);
    this._reset.next();
  }
}
